import { createFileRoute } from "@tanstack/react-router";
import { AiChatPage } from "../../../features/ai-concierge/pages/ai-chat-page";

/**
 * The page that ranks for the chat. The live surface lives at `/{lang}/ai-chat`
 * — rail, chat and map — and points its canonical here, because a chat has
 * nothing to read until someone types into it.
 *
 * `?q=` carries a question in from a link, which the page sends on arrival,
 * and canonicalises back to the bare URL so the variants never compete with
 * the page they lead into.
 */
export const Route = createFileRoute("/$lang/_layout/ai-travel-planner")({
  component: AiChatPage,
  validateSearch: (search: Record<string, unknown>): { q?: string } => {
    const q = typeof search.q === "string" ? search.q.trim() : "";
    return q ? { q: q.slice(0, 300) } : {};
  },
});
